import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import { Col, Row } from 'react-bootstrap';
import Logo from '../../../assets/images/logo.png';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  GetVerifyOtp,
  selectVerifyOtpPass
} from '../../../features/forgetPassword/verifyOtpSlice';
import {
  GetSetPassword,
  selectSetPassword
} from '../../../features/forgetPassword/setPasswordSlice';
//import { selectForgetPass } from "../../../features/forgetPassword/forgetPassSlice";
import '../login.css';
import { useHistory, useLocation } from 'react-router-dom';
import swal from 'sweetalert';
import { dev } from '../../../features/network/ApiCall';
var count: number = 300;
var md5 = require('md5');
const passRegex =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;

function UserRegister() {
  let history = useHistory();
  const location: any = useLocation();
  const [emailId, setEmailId] = useState('');
  const [newPassword, setnewPassword] = useState('');
  const [confirmPassword, setconfirmPassword] = useState('');
  const [otp, setOtp] = useState<any>();
  const Otp = (event: React.ChangeEvent<HTMLInputElement>) =>
    setOtp(event.target.value);
  const [passwordMatch, setpasswordMatch] = useState('');
  const NewPass = (event: React.ChangeEvent<HTMLInputElement>) =>
    setnewPassword(event.target.value);
  const ConfirmPass = (event: React.ChangeEvent<HTMLInputElement>) =>
    setconfirmPassword(event.target.value);
  const setPassword = useAppSelector(selectSetPassword);
  const verifyOtpSubmit = useAppSelector(selectVerifyOtpPass);
  const dispatch = useAppDispatch();
  // const forgetpassDetails = localStorage.getItem("forgetpass");
  // const getforgetpass: any = forgetpassDetails;
  // const getOtpJson = JSON.parse(getforgetpass);

  useEffect(() => {
    if (location?.state?.id) {
      setEmailId(location?.state?.id);
    } else {
      history.push('/NewUserRegister');
    }
  }, [location?.state]);

  const forgetpassDetails: any = localStorage.getItem('otp');
  let getOtpJson = JSON.parse(forgetpassDetails);

  const onSubmits = async (event: any) => {
    event.preventDefault();
    let data = {
      password: md5(newPassword),
      emailId: emailId,
      otp: otp
    };
    if (newPassword !== confirmPassword || newPassword == '') {
      setpasswordMatch('Password dont match !');
    } else if (!newPassword.match(passRegex)) {
      swal('Incorrect Password Format.', '', 'error');
    } else {
      // await dispatch(GetSetPassword(data));
      // setpasswordMatch("");
      var axios = require('axios');
      var config = {
        method: 'put',
        url: `${dev}/register/setpassword`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      axios(config)
        .then(function (response: any) {
          // console.log(response.data);
          // localStorage.setItem('otp', JSON.stringify(response.data.otp));
          if (response?.data?.user !== null) {
            history.push(`/registersuccess`);
            localStorage.removeItem('forgetpass');
            localStorage.removeItem('otp');
          }
        })
        .catch(function (error: any) {
          // console.log(error);
          swal('Something went wrong!', 'error');
        });
    }
  };
  let colour1 = 'red',
    colour2 = 'red',
    colour3 = 'red',
    colour4 = 'red',
    colour5 = 'red';
  if (newPassword.match(passRegex)) {
    colour4 = 'green';
  }
  if (newPassword === confirmPassword && newPassword !== '') {
    colour5 = 'green';
  }

  const ResendOTP = () => {
    var axios = require('axios');
    var config = {
      method: 'post',
      url: `${dev}/register/resendotp`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: location?.state?.data
    };
    axios(config)
      .then(function (response: any) {
        // console.log(JSON.stringify(response.data));
        // localStorage.setItem("otp", JSON.stringify(response.data.otp));
        if (response.status == 200) {
          history.push({
            pathname: `/setuserpassword/`,
            state: {
              id: emailId,
              data: location?.state?.data
            }
          });
        }
      })
      .catch(function (error: any) {
        // console.log(error);
        swal('Something went wrong!', 'error');
      });
  };

  // console.log("location data ====>", location?.state?.data);

  return (
    <>
      <Container fluid style={{ height: 'auto' }}>
        <Row sm={3}>
          <Col></Col>
          <Col
            className='bg-white tb-mar-mob0-desk48 mx-auto loginshadow'
            xxl={3}
            xs={10}
          >
            <div className='my-5 lr-mar-mob4-desk24 py-5'>
              <Image
                className='mx-auto d-block'
                style={styles.limg}
                src={Logo}
              />
              <div className='mt-2 mb-3' style={styles.head}>
                Ethics and governance portal
              </div>
              <Form onSubmit={onSubmits}>
                <p>
                  <i
                    style={{ color: colour4, fontSize: '20px' }}
                    className='fa fa-check-circle'
                    aria-hidden='true'
                  ></i>
                  Password should contain minimum 8 characters. It must have 1
                  uppercase letter, 1 lowercase letter, 1 digit and 1 special
                  character.
                </p>
                <Form.Group className='mb-3'>
                  <Form.Control
                    className='shadow-none'
                    style={styles.text3}
                    type='password'
                    id='NewPassword'
                    name={newPassword}
                    onChange={NewPass}
                    placeholder='New Password'
                    required
                  />
                </Form.Group>
                <Form.Group className='mb-3'>
                  <Form.Control
                    className='shadow-none'
                    style={styles.text3}
                    type='password'
                    id='ConfirmPassword'
                    name={confirmPassword}
                    onChange={ConfirmPass}
                    placeholder='Confirm Password'
                    required
                  />
                </Form.Group>
                <Form.Group className='mb-3'>
                  <Form.Control
                    className='shadow-none'
                    style={styles.text3}
                    type='text'
                    id='otp'
                    name={otp}
                    onChange={Otp}
                    placeholder='OTP'
                    required
                  />
                  <p style={styles.grey}>
                    OTP is sent to your official email ID. Kindly check your
                    inbox
                  </p>
                </Form.Group>
                <Form.Group className='mb-3'>
                  {confirmPassword === '' ? (
                    ''
                  ) : newPassword === confirmPassword ? (
                    <p style={{ color: 'green', fontWeight: 'bold' }}>
                      {' '}
                      Passwords match{' '}
                    </p>
                  ) : (
                    <p style={{ color: 'red', fontWeight: 'bold' }}>
                      {' '}
                      Passwords not match{' '}
                    </p>
                  )}
                  {/* <label className="text-danger"> {passwordMatch}</label> */}
                </Form.Group>
                <Button style={styles.btn1} variant='danger' type='submit'>
                  <label className='pt-2'>Submit</label>
                </Button>
              </Form>
              <br />
              <p style={styles.text4} onClick={ResendOTP}>
                Resend OTP
              </p>
            </div>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </>
  );
}

const styles: any = {
  head: {
    fontFamily: 'Georama-Regular',
    fontSize: '18px',
    fontWeight: '500',
    textAlign: 'center'
  },
  limg: {
    width: '159px',
    height: '22px'
  },
  img1: {
    width: '24px',
    height: '24px'
  },
  img2: {
    width: '56px',
    height: '56px'
  },
  text1: {
    textAlign: 'center',
    fontFamily: 'Saira',
    fontSize: '16px',
    fontWeight: '600',
    color: 'black',
    textDecoration: 'none'
  },
  text2: {
    textAlign: 'center',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '500',
    color: '#6d6e71'
  },
  text3: {
    fontFamily: 'Saira',
    fontSize: '16px'
  },
  text4: {
    textAlign: 'center',
    fontFamily: 'Saira',
    fontSize: '14px',
    fontWeight: '500',
    color: '#e31837'
  },
  text5: {
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '600',
    color: '#f3901d'
  },
  btn1: {
    width: '100%',
    height: '48px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '600',
    color: 'white',
    borderRadius: '0px'
  }
};

export default UserRegister;
